define.alias("shared/components/shared/wizard", "calendar/components/shared/wizard");